export default {
  STRIPE: 'STRIPE',
  STRIPE_TERMINAL: 'POS STRIPE TERMINAL',
  AFFIRM: 'AFFIRM',
};
